/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Portal API Gateway
 * OpenAPI spec version: 2.0.0
 */
import {
  useQuery,
  type DataTag,
  type QueryClient,
  type QueryFunction,
  type QueryKey,
  type UseQueryOptions,
  type UseQueryReturnType,
} from "@tanstack/vue-query"
import { unref } from "vue"

import { customInstance, type ErrorType } from ".././client.ts"
import { useQueryOptions } from ".././queryOptions.ts"
import type { Error, OfgemUsageProfilesResponse } from "../model"

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1]

/**
 * @summary Get Ofgem usage profiles for Low, Medium and High usage intensities
 */
export const getOfgemUsageProfiles = (
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<OfgemUsageProfilesResponse>(
    { url: `/api/v1/energyUsage/profiles/ofgem`, method: "GET", signal },
    options,
  )
}

export const getGetOfgemUsageProfilesQueryKey = () => {
  return ["api", "v1", "energyUsage", "profiles", "ofgem"] as const
}

export const useGetOfgemUsageProfilesQueryOptions = <
  TData = Awaited<ReturnType<typeof getOfgemUsageProfiles>>,
  TError = ErrorType<Error>,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getOfgemUsageProfiles>>,
      TError,
      TData
    >
  >
  request?: SecondParameter<typeof customInstance>
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {}

  const queryKey = getGetOfgemUsageProfilesQueryKey()

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getOfgemUsageProfiles>>
  > = ({ signal }) => getOfgemUsageProfiles(requestOptions, signal)

  const customOptions = useQueryOptions(
    { queryKey, queryFn, ...queryOptions },
    {},
  )

  return customOptions as UseQueryOptions<
    Awaited<ReturnType<typeof getOfgemUsageProfiles>>,
    TError,
    TData
  >
}

export type GetOfgemUsageProfilesQueryResult = NonNullable<
  Awaited<ReturnType<typeof getOfgemUsageProfiles>>
>
export type GetOfgemUsageProfilesQueryError = ErrorType<Error>

/**
 * @summary Get Ofgem usage profiles for Low, Medium and High usage intensities
 */

export function useGetOfgemUsageProfiles<
  TData = Awaited<ReturnType<typeof getOfgemUsageProfiles>>,
  TError = ErrorType<Error>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getOfgemUsageProfiles>>,
        TError,
        TData
      >
    >
    request?: SecondParameter<typeof customInstance>
  },
  queryClient?: QueryClient,
): UseQueryReturnType<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>
} {
  const queryOptions = useGetOfgemUsageProfilesQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> }

  query.queryKey = unref(queryOptions).queryKey as DataTag<
    QueryKey,
    TData,
    TError
  >

  return query
}
